import { Component, OnInit, ViewChild } from '@angular/core';
import { Platform, ModalController, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService, MessageclientService, NativeService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { GridBaseCase } from '../../../grid/grid.base.case';
import { WebParameterContext } from 'src/model/common';
import { WxjssdkService }from "src/service/wxjssdk.service";
declare var app;
@Component({
  selector: 'app-evaluation-management',
  templateUrl: './evaluation-management.component.html',
  styleUrls: ['./evaluation-management.component.scss']
})
export class EvaluationManagementComponent extends  GridBaseCase {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  PageNumber:any;
  dataArrayList: Array<any> = [];//数据列表
  AvgScore:any; // 评价总人数
  AvgScorenum:any;
  People:any; // 评价的总分
  isLoadAllData: boolean = false;//数据是否加载完成
  clickLoadMoreData: boolean = false;//点击加载更多数据
  isFirstLoad:boolean = true;
  information: any = {};
  dataArrayListarr:Array<any> = [];
  show:boolean=false ; // 活动按钮是否显示
  content:any;// 获取的粘贴内容
  userID:any;
  stars:Number = 0;
  allName:any;// 名称
  grayshow: boolean= false;  
  QYWXQRCodestyle:any; // 企业为微信二维码 
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController,
    public wx:WxjssdkService,
    private msg: MessageclientService,
  ) { 
    super();
    this.LoadData(1);
  }

  ngOnInit() {
  }
  loadMoreData(event) {
    let that = this;

    if (that.RecordCount == that.dataArrayList["Ratings"].length) {
      that.isLoadAllData = true;
    }else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
      that.clickLoadMoreData = true;
    }
  }

  LoadData(PageNumber) {
    // that.information = that.com.GetStorageKey("information")||{};
    var that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }

    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "GetUserScoreBySNC";
    body.OpType = "query";
    body.ConfigType = "form";
    body.Client.ApiType = "Element";
    body.Client.ClientType = 0;
    let typeObj = {};
    
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.isFirstLoad = false;
      that.clickLoadMoreData = false;
      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {

        that.dataArrayList = data.Status||{};
        that.AvgScore=that.dataArrayList["AvgScore"];
        that.AvgScorenum = parseInt(that.dataArrayList["AvgScore"]||0);
        that.stars =  that.AvgScorenum;
        that.content = that.dataArrayList["Msg"];
        console.log(that.stars,"星星分数")
        that.People= that.dataArrayList["People"]||0;
        that.show  = that.dataArrayList["Show"]||false;
        console.log(that.dataArrayList, "dataArrayList");
        if(!that.dataArrayList["Ratings"]){
          that.dataArrayList["Ratings"]=[];
        }
        that.dataArrayList["Ratings"].forEach(item=>{
          item.addtime= item.addtime.replace(/-/g,"/").replace("T","");
        })
        /****上拉加载数据begin****/
        that.RecordCount = data.Status["Total"];
        if (that.RecordCount == data.Status["Ratings"].length || that.RecordCount == that.dataArrayList["Ratings"].length) {
          // that.infiniteScroll.disabled = true;
          that.isLoadAllData = true;
        } else {
          that.isLoadAllData = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.isFirstLoad = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
    });
  }
    /**
 * 当前人如果没有微信，则需要去选择微信联系人，并且获取对应的userID
 * @param userID 获取当前选中的微信对应的userID
 * @param id 当前会员的ID
 */
// EventListBind(userID:string){
//   const that=this;
//   const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
//   let body = new WebParameterContext();
//   body.Account = that.com.GetAccount;
//   body.ConfigName = "GetUserMessage";
//   body.OpType = "query";
//   body.ConfigType = "view";
//   body.RowsPerPage = app.RowsPerPage;
//   body.PageNumber = 0;
//   body.Client.PageName = PageName;
//   body.Client.ApiType = "Element";
//   body.Client.Name = that.element.name;
//   body.Client.ClientType = 2;
  
//   body.RequestBody=JSON.stringify({"openid":userID});
//   that.msg.Loading("请求中，请稍后...").then(loads=>{
//     that.http.post(app.DEFAULTURL, body).then(data => {
//       loads.dismiss();
//       /****判断是否第一页end****/
//       if (data.ResponseMessage.Success) {
//         console.log(data,"添加会员的userID到数据库中成功");
//         console.log(data,"拿到得数据结果");
//         that.userID = data.Status.Datas;  // 拿到的userid
//         that.content = data.Status.Message; // 拿到的发送内容
//          try {
//           var aux = document.createElement("input"); 
//           console.log(aux);
//             aux.setAttribute("value", that.content); 
//             document.body.appendChild(aux); 
//             aux.select();
//             document.execCommand("copy"); 
//             document.body.removeChild(aux);
//             console.log(aux);
//            console.log("打开微信"); 
//             that.wx.SetClipboardData(that.content).then(res=>{
//               // that.msg.Alert(JSON.stringify(res));
            
//             }).catch(err=>{
//               // that.msg.Alert(JSON.stringify(err));
//             });
//          }catch(err){}
//          that.wx.CreateopenEnterpriseChat("",that.userID,"").then(res=>{
//           // that.msg.Alert(JSON.stringify(res));
//          }).catch(res=>{
//           // that.msg.Alert(JSON.stringify(res));
//           that.msg.Alert("对方不是您好友");
//          });
//       } else {
//         that.msg.Alert(data.ResponseMessage.ErrorMessage);
//       }
//     }).catch(error => {
//       loads.dismiss();
//       console.log(error);
//       that.msg.Alert(error.ResponseMessage.ErrorMessage);
//     });
//     loads.present();
//   });
 
// }



/**
 * 
 * @param userID 
 * 判断按钮是否颜色亮与否
 */
EventListBind(item,index){
  const that=this;
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "AddTBEvaluationLog";
  body.OpType = "add";
  body.ConfigType = "form";
  body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = 0;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  let arrSale ={
    "addtime":item.addtime,
    "content":item.content,
    "id":item.id,
    "num":item.num,
    "openid":item.openid,
    "realname":item.allName,
    "serial_number":item.serial_number,
    "stage":item.stage,
    "status":item.status,
    "uniacid":item.uniacid,
    "updatetime":item.updatetime
  }
  body.RequestBody=JSON.stringify(arrSale);
  // that.msg.Loading("请求中，请稍后...").then(loads=>{
    that.http.post(app.DEFAULTURL, body).then(data => {
      // loads.dismiss();
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        console.log(data);
        debugger;
        that.dataArrayList["Ratings"][index].IsClick=false;
      } else {
        // that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      // loads.dismiss();
      console.log(error);
      // that.msg.Alert(error.ResponseMessage.ErrorMessage);
    });
    // loads.present();
  // });
 
}



/**
 * //获取企业微信二维码
 */
  
  downloadPGLink(){
    let that=this;
    let body = new WebParameterContext();
    body.ConfigName = "SystemUser";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = "ScanCodeSales";
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    let _QYWXId = that.com.GetAccount.QYWXId;
    let _QYWXIdType = that.com.GetAccount.QYWXIdType;
    let _QYCode = localStorage.getItem("QYCode");
    if(_QYWXId && _QYWXIdType == '0'){
      body.RequestBody = JSON.stringify({
        QYWXId:_QYWXId,
        QYCode:_QYCode,
        type:1
      });


    }else{
      that.msg.Alert("您的企业微信二维码还未生成，请联系管理员")
      return;
    }
    that.msg.Loading("加载中，请稍后").then(load=>{
      that.http.post(app.DEFAULTURL, body).then(data => {
        load.dismiss();
        if(data.ResponseMessage.Success){
          console.log(data,"结果");
          if(data.Status){
      
               that.QYWXQRCodestyle=data.Status.QYWXQRCode;
          that.com.setHistoryUrl();
         this.com.Go('/tabs/wechatQrcod/'+ this.com.getNowDatetime,{
            QYWXQRCodestyle: that.QYWXQRCodestyle,
         });
           
          }else{
            that.msg.Alert(app.ERRORMESSAGE);
          }
        }else{
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }
    ).catch(error => {
       load.dismiss();
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
      console.log(error);
    });
      load.present();
    }).catch(err=>{
      console.log(err);
    })
     
   
  }
  /**
  * 打开微信
  */
 Eventweixin(item,index){
  const that=this;
  let newcontent= that.content.replace("{0}",item.allName);
  console.log(newcontent);
 
  // try{
  //   that.EventListBind(urerid);
  // }catch(err){
  // }
         try {
          var aux = document.createElement("input"); 
          console.log(aux);
            aux.setAttribute("value", newcontent); 
            document.body.appendChild(aux); 
            aux.select();
            document.execCommand("copy"); 
            document.body.removeChild(aux);
            console.log(aux);
           console.log("打开微信"); 
            that.wx.SetClipboardData(newcontent).then(res=>{
              // that.msg.Alert(JSON.stringify(res));
            
            }).catch(err=>{
              // that.msg.Alert(JSON.stringify(err));
            });
           
         }catch(err){}
         that.wx.CreateopenEnterpriseChat("",item.UserId,"").then(res=>{
           try{
            that.EventListBind(item,index);
           }catch{
              
           }
          // that.msg.Alert(JSON.stringify(res));
         }).catch(res=>{
          // that.msg.Alert(JSON.stringify(res));
          that.msg.Alert("经系统检测对方不是您好友，请对方扫描您的企业微信二维码添加好友").then(res=>{
             that.downloadPGLink();
          })
         });
 }


}













 

